import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	LandFormInput,
	LandFormOutput,
} from "web_myplann/Portfolio/Forms/LandForm/landFormSchema";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";

type Props = {
	control: Control<LandFormInput, unknown, LandFormOutput>;
};

const PageResources = Resources.Portfolio.AddLand;

export const LandIdentityFields = ({ control }: Props) => {
	const { t } = useResource();

	return (
		<>
			<FlatRowFormInput
				control={control}
				name="location"
				label={t(PageResources.Fields.location)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
			/>
			<FlatRowFormInput
				control={control}
				name="locationMunicipality"
				label={t(PageResources.Fields.locationMunicipality)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
			/>
			<FlatRowFormInput
				control={control}
				name="locationZipCode"
				label={t(PageResources.Fields.locationZipCode)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				inputMode="numeric"
			/>
		</>
	);
};
